<span class="utility-apps-container">
  @for (utility of noPassUtilityApps; track utility.link) {
    @if ((utility.right && rights?.includes(utility.right)) || !utility.right) {
      <button
        type="button"
        mat-stroked-button
        class="menu-button utility-app"
        (click)="goToPage(utility.link)"
      >
        {{ utility.label }} <mat-icon>{{ utility.icon }}</mat-icon>
      </button>
    }
  }

  @if (showLearnButton) {
    <button
      type="button"
      mat-stroked-button
      class="menu-button utility-app"
      (click)="goToPage('/training')"
    >
      Training<mat-icon>school</mat-icon>
    </button>
  }

  @if (hasUtilityApps) {
    <button
      type="button"
      mat-stroked-button
      class="menu-button utility-app-toggle"
      [matMenuTriggerFor]="utilityAppMenu"
    >
      <mat-icon class="me-0">widgets</mat-icon>
    </button>
  }

  <mat-menu
    #utilityAppMenu="matMenu"
    direction="down"
    yPosition="below"
    class="unified-menu"
  >
    @for (utility of noPassUtilityApps; track utility.link) {
      @if (
        (utility.right && rights?.includes(utility.right)) || !utility.right
      ) {
        <button
          type="button"
          mat-menu-item
          class="menu-button"
          (click)="goToPage(utility.link)"
        >
          <mat-icon>{{ utility.icon }}</mat-icon> {{ utility.label }}
        </button>
      }
    }
    @if (showLearnButton) {
      <button
        type="button"
        mat-menu-item
        class="menu-button"
        (click)="goToPage('/training')"
      >
        <mat-icon>school</mat-icon> Training
      </button>
    }
  </mat-menu>
</span>
